export default __webpack_public_path__ + "static/media/mobile_08.5937b8db.png";